
<template>
  <div>
    <md-steppers :md-active-step.sync="active" md-linear>
      <md-step id="first" md-label="Use Event Bin to capture event body sample" :md-editable="false">
        <p>
          <span class="md-headline">
            1. Copy URL below to the BeProduct Event API endpoint settings (<a @click="showHelp('event_copy')" href="#">
              example </a>).
          </span>

          <md-field>
            <label>Event url</label>
            <md-input v-model="url" disabled></md-input>
            <md-button class="md-icon-button">
              <md-icon v-on:click.native="copyTextToClipboard(url)">content_copy</md-icon>
            </md-button>
          </md-field>
        </p>
        <br />
        <p>
          <span class="md-headline">2. Trigger event in BeProduct and select it in the list below (<a
              @click="showHelp('event_trigger')" href="#"> example </a>).
          </span>
        </p>
        <p v-for="event in events" :key="event">
          <md-radio :value="event" v-model="selected_event"> Incoming event {{
            event.replace(/^.*[\\\/]/, "").replace(/\.[^/.]+$/, "")
          }}</md-radio>
        </p>
        <p v-if="selected_event == null">
          <md-progress-spinner :md-diameter="12" :md-stroke="3" md-mode="indeterminate">
          </md-progress-spinner>
          <span>&nbsp;WAITING FOR INCOMING EVENTS - {{ timerMsg }}</span>
        </p>
        <p>
          <md-button v-if="selected_event != null" class="md-raised md-primary"
            @click="getScriptContent(false); setDone('first', 'second')">PROCEED TO SOURCE CODE</md-button>
        </p>
        <br />
        <md-divider></md-divider>
        <br />
        <br />
        <br />
        <p>
          <b>Or</b> <a @click="getScriptContent(false); setDone('first', 'second')" href="#">SKIP</a> above steps
          altogether if you already know event data format or your already have your automation script ready.
        </p>
      </md-step>

      <md-step id="second" md-label="Automation Source Code">
        <p>
          <md-field>
            <label>Final Automation URL</label>
            <md-input ref="finalurl" v-model="final_url" disabled></md-input>
            <md-button class="md-icon-button">
              <md-icon v-on:click.native="copyTextToClipboard(final_url, 'finalurl')">content_copy</md-icon>
            </md-button>
          </md-field>
        </p>

        <md-field>
          <label>Automation Name</label>
          <md-input :disabled="saving" v-model="settings.name">
          </md-input>
        </md-field>
        <md-field>
          <label>Automation Description</label>
          <md-textarea v-model="settings.description" :disabled="saving" md-autogrow></md-textarea>
        </md-field>
        <md-switch :disabled="saving" v-model="settings.enabled">Automation is {{ settings.enabled ? "enabled" : "disabled
          (YOUR CODE WILL NOT BE EXECUTED WHEN AUTOMATION URL IS CALLED)"}} </md-switch>
        <br />
        <md-divider></md-divider>
        <br />

        <md-menu md-direction="top-start">
          <md-button v-on:click.native="saveScript()" md-menu-trigger :disabled="saving">
            <md-icon class="pointer">save</md-icon>
            save
          </md-button>
          <md-button @click.native="showOpenFileDialog()" :disabled="saving" md-menu-trigger>
            <md-icon class="pointer">file_upload</md-icon>
            upload
          </md-button>
          <md-button md-menu-trigger @click.native="saveFile()" :disabled="saving">
            <md-icon class="pointer">file_download</md-icon>
            download
          </md-button>
          <md-button md-menu-trigger @click.native="openLog()" :disabled="saving">
            <md-icon class="pointer">history</md-icon>
            logs
          </md-button>
          <md-button v-on:click.native="getScriptContent(true)" :disabled="saving" class="md-accent" md-menu-trigger>
            <md-icon class="pointer">delete</md-icon>
            reset
          </md-button>
          <!--md-button
            v-on:click.native="saveAndRunScript()"
            :disabled="saving || !selected_event"
            md-menu-trigger
          >
            <md-icon class="pointer">play_arrow</md-icon>
            save and run{{selected_event ? '' : ' - TO ENABLE CHOOSE EVENT IN STEP 1 AS YOUR EVENT_DATA'}}
          </md-button-->
        </md-menu>
        <md-progress-bar v-if="saving || executing" md-mode="indeterminate"></md-progress-bar>

        <md-toolbar class="md-accent md-dense" v-if="code != dirty">
          <span class="md-subheading">You have unsaved changes</span>
        </md-toolbar>
        <!-- Two-way Data-Binding -->
        <codemirror v-model="dirty" :options="cmOptions" />
      </md-step>
    </md-steppers>
    <md-dialog-alert :md-active.sync="savedScriptDialog" md-content="Your script has been saved!" md-confirm-text="Ok" />

    <md-dialog-alert :md-active.sync="runScriptDialog" md-content="Your script has been executed succesfully!"
      md-confirm-text="Ok" />
    <md-dialog-alert :md-active.sync="errorScriptDialog" :md-content="errorScriptMsg" md-confirm-text="Ok" />
    <md-dialog :md-active.sync="howToShow">

      <md-dialog-title v-if="howToSection == 'event_copy'">Create BeProduct event using Event Bin url</md-dialog-title>
      <md-dialog-title v-if="howToSection == 'event_trigger'">Trigger BeProduct event</md-dialog-title>

      <md-dialog-content v-if="howToSection == 'event_copy'">
        <p>
          <img src="@/assets/step1.gif" width="800" />
        </p>
      </md-dialog-content>
      <md-dialog-content v-if="howToSection == 'event_trigger'">
        <p>
          <img src="@/assets/step2.gif" width="800" />
        </p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="(howToShow = false)">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
const BASE_URL = process.env.VUE_APP_FUNCTIONURL;

import { v4 as uuid4 } from "uuid";
import axios from "axios";
import { codemirror } from "vue-codemirror";

// import base style
import "codemirror/lib/codemirror.css";
import "codemirror/mode/python/python.js";

// import theme style
import "codemirror/theme/gruvbox-dark.css";

export default {
  name: "Automation",
  components: {
    codemirror,
  },
  computed: {
    final_url: {
      get() {
        return `${BASE_URL}/api/automate?logicId=${this.logicId}&company=${this.$route.params.company}`;
      },
      set() { },
    },
    url: function () {
      return `${BASE_URL}/api/automate?logicId=${this.logicId}&company=${this.$route.params.company}`;
    },
  },
  data: () => ({
    logicId: "",
    active: "first",
    timer: null,
    timerMsg: "",
    events: [],
    selected_event: null,
    target: "custom",
    dirty: "",
    code: "loading script...",
    cmOptions: {
      tabSize: 4,
      mode: "python",
      theme: "gruvbox-dark",
      lineNumbers: true,
      line: true,
      indentUnit: 4,
      indentWithTabs: false,
      extraKeys: {
        "Tab": function (cm) {
          cm.replaceSelection("    ", "end");
        }
      }
      // more CodeMirror options...
    },
    eventContent: "",
    savedScriptDialog: false,
    runScriptDialog: false,
    errorScriptDialog: false,
    errorScriptMsg: "",
    howToShow: false,
    howToSrc: "",
    howToSection: "copy_event",
    settings: {
      name: "Untitled",
      description: "",
      enabled: true,
    },
    saving: true,
    executing: false,
    i: 0,
  }),
  created() {
    let id = null;
    if (!this.$route.params.id) {
      id = uuid4();
      this.$router.push({
        name: "Automation",
        params: { company: this.$route.params.company, id: id },
      });
    }
    this.logicId = id ?? this.$route.params.id;
    this.timer = setTimeout(this.fetchOnTimer, 1000);
    this.dirty = this.code;
    if (this.$route.query.edit) this.active = "second";
  },
  mounted() {
    if (this.$route.query.edit) this.getScriptContent(false);
  },
  methods: {
    setDone(id, index) {
      this[id] = true;

      if (index) {
        this.active = index;
      }
    },
    fetchOnTimer() {
      if (this.i == 0) {
        this.timerMsg = "Checking now...";
        this.i = 5;
        this.fetchEventsList();
      } else {
        this.timerMsg = `Checking in ${this.i--} sec.`;
      }
      this.timer = setTimeout(this.fetchOnTimer, 1000);
    },
    fetchEventsList() {
      if (this.active != "first") return;
      axios
        .get(
          `${BASE_URL}/api/eventbin-list?id=${this.logicId}&company=${this.$route.params.company}`
        )
        .then((response) => {
          this.events = response.data.events;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    saveScript() {
      this.saving = true;
      axios
        .post(
          `${BASE_URL}/api/logic-script?id=${this.logicId}&company=${this.$route.params.company}`,
          {
            text: this.dirty,
            settings: this.settings,
          }
        )
        .then((response) => {
          this.code = this.dirty;
          this.savedScriptDialog = true;
          this.saving = false;
          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    saveAndRunScript() {
      this.saving = true;
      this.executing = true;
      let eventDate = this.selected_event
        .split(/(\\|\/)/g)
        .pop() //just filename
        .replace(/\.[^/.]+$/, ""); //strip extension
      let self = this;

      axios
        .post(
          `${BASE_URL}/api/logic-script?id=${this.logicId}&company=${this.$route.params.company}`,
          {
            text: this.dirty,
            settings: this.settings,
          }
        )
        .then((response) => {
          // GET EVENT SOURCE
          this.code = this.dirty;
          this.saving = false;
          axios
            .get(
              `${BASE_URL}/api/eventsource?id=${self.logicId}&company=${this.$route.params.company}&eventfile=${eventDate}`
            )
            .then((response) => {
              let eventJSON = response.data;
              console.log(eventJSON);

              // CALLING FUNCTION WITH EVENT JSON
              axios
                .post(
                  `${BASE_URL}/api/automate?ignoredisabled=true&logicId=${self.logicId}&company=${self.$route.params.company}`,
                  eventJSON
                )
                .then((response) => {
                  self.runScriptDialog = true;
                  self.executing = false;
                  console.log(response);
                })
                .catch((error) => {
                  self.executing = false;
                  console.log(error);
                  if (error.response) self.errorScriptMsg = error.response.data;
                  else self.errorScriptMsg = String(error);
                  self.errorScriptDialog = true;
                });
            })
            .catch((error) => console.log("ERROR LOADING EVENT:\n" + error));
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getScriptContent(reset) {
      this.saving = true;
      let self = this;
      let eventDate = this.selected_event
        ? this.selected_event
          .split(/(\\|\/)/g)
          .pop() //just filename
          .replace(/\.[^/.]+$/, "") //strip extension
        : null;
      axios
        .get(
          `${BASE_URL}/api/logic-script?id=${this.logicId}&company=${this.$route.params.company}&target=custom&reset=${reset}&event_date=${eventDate}`
        )
        .then((response) => {
          self.dirty = response.data.text;
          self.settings = response.data.settings;
          if (response.data.found && !reset) self.code = self.dirty;
          this.saving = false;
          console.log(response);
        })
        .catch(function (error) {
          self.code = self.dirty = "ERROR LOADING SCRIPT:\n" + error;
        });
    },
    fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard(text, ref) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
      } else
        navigator.clipboard.writeText(text).then(
          function () {
            console.log("Async: Copying to clipboard was successful!");
          },
          function (err) {
            console.error("Async: Could not copy text: ", err);
          }
        );

      if (ref);
      // console.log(this.$refs[ref]);
      // TODO: Select text here
    },

    showOpenFileDialog() {
      const pickerOpts = {
        types: [
          {
            description: "Python script",
            accept: {
              "text/*": [".py", ".txt"],
            },
          },
        ],
        excludeAcceptAllOption: true,
        multiple: false,
      };
      let _this = this;
      window.showOpenFilePicker(pickerOpts).then(
        (fileHandles) => {
          var fileHandle = fileHandles[0];
          fileHandle.getFile().then(
            (file) => {
              var reader = new FileReader();
              reader.onload = function () {
                _this.dirty = reader.result;
              };
              reader.readAsText(file);
            },
            function (error) {
              console.log(error);
            }
          );
        },
        function (error) {
          console.log(error);
        }
      );
    },
    saveFile() {
      const opts = {
        suggestedName: this.settings.name + ".py",
        types: [
          {
            description: "Python script",
            accept: { "text/plain": [".py"] },
          },
        ],
      };
      let _this = this;
      window.showSaveFilePicker(opts).then(
        (fileHandle) => {
          fileHandle.createWritable().then(
            (stream) =>
              stream.write(_this.dirty).then(
                () => stream.close(),
                (e) => console.log(e)
              ),
            (error) => console.log(error)
          );
        },
        (error) => console.log(error)
      );
    },
    showHelp(helpSection) {
      this.howToShow = true;
      this.howToSection = helpSection;
    },
    openLog() {
      const url = this.$router.resolve({
        name: "Log",
        params: {
          company: this.$route.params.company,
          id: this.$route.params.id,
        },
      });
      window.open(url.href, "_blank");
    },
  },
};
</script>
<style lang="css">
.md-steppers {}

.CodeMirror {
  height: auto;
}

.pointer {
  cursor: pointer;
}

.additional-margin {
  padding-right: 50px !important;
}
</style>
